import axios from "axios";
import { BASE_URL } from "./baseUrl";
import { getClientSource } from "./Functions";

/**
 * Loads the PDF through the API (Bearer auth). Not encrypted JSON — raw binary stream.
 */
export async function fetchCompanyPolicyPdfBlob() {
  const accessToken = localStorage.getItem("accessToken");
  const res = await axios.get(`${BASE_URL}/api/company-policy/view`, {
    responseType: "arraybuffer",
    headers: {
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
      company_source: getClientSource(),
    },
    validateStatus: () => true,
  });

  if (res.status === 401) {
    window.location.href = "/login";
    throw new Error("Unauthorized");
  }

  if (res.status !== 200) {
    throw new Error("Could not load the company policy document.");
  }

  const buf = res.data;
  if (buf.byteLength >= 4) {
    const u = new Uint8Array(buf);
    const looksPdf =
      u[0] === 0x25 && u[1] === 0x50 && u[2] === 0x44 && u[3] === 0x46;
    if (!looksPdf) {
      throw new Error("Unexpected response when loading the policy.");
    }
  }

  return new Blob([buf], { type: "application/pdf" });
}
